import { render, staticRenderFns } from "./LayerAddingDialog.vue?vue&type=template&id=56175cf6&scoped=true&"
import script from "./LayerAddingDialog.vue?vue&type=script&lang=js&"
export * from "./LayerAddingDialog.vue?vue&type=script&lang=js&"
import style0 from "./LayerAddingDialog.vue?vue&type=style&index=0&id=56175cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56175cf6",
  null
  
)

export default component.exports